(function () {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('ControlBarController', ControlBarController);

    ControlBarController.$inject = ['$rootScope', '$scope', '$state', 'Auth', 'Principal',
        'ProfileService', 'LoginService', 'AdminLTEService'];

    function ControlBarController($rootScope, $scope, $state, Auth, Principal, ProfileService,
                                  LoginService, AdminLTEService) {
        var vm = this;
        vm.isControlbarCollapsed = true;
        AdminLTEService.registerControlSidebar();

        ProfileService.getProfileInfo().then(function(response) {
            vm.inProduction = response.inProduction;
            vm.swaggerEnabled = response.swaggerEnabled;
        });
    }
})();
